module.exports = __webpack_public_path__ + "static/media/施工前.e8fca016.jpg";